import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BinModel, BinAvailabilityContainer } from '../../../../../../models/aggregates/erp/stock';
import { BaseApiTemplateService, Core2Config, Pagination, ApiVisa, PagingResponseModel } from '../../shared';

@Injectable({
  providedIn: 'root'
})
export class BinService extends BaseApiTemplateService<BinModel> {

  constructor(http: HttpClient) {
    super();
    this.endpoint_path = `${Core2Config.TENANT_DOMAIN_URL_PREFIX}${Core2Config.ERP_PREFIX}inv/bins`;
    this.httpClient = http;
  }

  getBinAvailabilityByCriteria(pagination: Pagination, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX
        + "inv/bins/" + "bin-availability/" + Core2Config.BACKOFFICE_EP_SUFFIX;
    }
    const UrlByCriteria = this.apiUrl + '?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<BinAvailabilityContainer>>(UrlByCriteria, this.getHttpHeader(visa));
  }
}